module.exports = __webpack_public_path__ + "img/BFishingBoat64_ua.63da585d.webp";